export const ProjectUserStatus = {
  INVITED: 1,
  ACCEPTED: 2,
  DECLINED: 3,
  TASKS_PICKED: 4,
  CHOSEN: 5,
  CONTRACT_ACCEPTED: 6,
  NOT_CHOSEN: 7,
  UNRESPONSIVE: 8,
  ACTIVE: 9,
  RATING: 10,
  COMPLETED: 11,
  STOPPED: 12,
  TASKS_COMPLETED: 13,
  contains: function (statusId, statuses) {
    if (statuses.includes(statusId)) {
      return true;
    }
    return false;
  },
  isConfirmedTeam(statusId) {
    return this.contains(statusId, [
      this.TASKS_PICKED,
      this.CONTRACT_ACCEPTED,
      this.ACTIVE,
      this.TASKS_COMPLETED,
      this.RATING,
      this.COMPLETED,
    ]);
  },
  isNotMember(statusId) {
    return this.contains(statusId, [
      this.DECLINED,
      this.NOT_CHOSEN,
      this.UNRESPONSIVE
    ]);
  },
  isActive(statusId) {
    return this.contains(statusId, [
      this.ACTIVE,
      this.TASKS_COMPLETED
    ]);
  },
  isCompleted(statusId) {
    return this.contains(statusId, [
      this.RATING,
      this.COMPLETED
    ]);
  },
  isWaiting(statusId) {
    return this.contains(statusId, [
      this.INVITED,
      this.ACCEPTED,
      this.CHOSEN,
      this.TASKS_PICKED,
    ]);
  },
}